import { useSelector } from "react-redux";
import { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import {selectPortfoliosWithSignals, selectStarredPortfolios} from "../store/slices/portfolios.slice";
import { selectUserFields } from "../store/slices/user.slice";
import {Card, Tabs, Row, Col, Typography, Divider, Space, Tooltip} from "antd";
import { InfoCircleOutlined, StepForwardOutlined} from "@ant-design/icons";
import Alert from "@mui/material/Alert";
import { EventOutlined, FoundationRounded, UnfoldMoreRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import React from "react";
import WidgetContainer from "../components/WidgetContainer";
import PortfolioList from "./Portfolio/PortfolioList";
import { AutoAwesomeOutlined } from "@mui/icons-material";
import {filterUserAppsIntoCategories} from "../configs/AppsConfig";
import useTickerCalendar from "./TickerCalendar/useTickerCalendar";
import BuilderStatesManager from "./Builders/BuilderStatesManager";
import {useEnsureTickersLoaded} from "../hooks/useEnsureTickersLoaded";
import LogoCloud from "../components/Graphics/LogoCloud";
import Widget from "../components/Widget";
import ContentGrid from "../components/ContentGrid";
import CompanyCard from "./Dashboard/components/CompanyCard";
import UpcomingEventsCard from "./Dashboard/components/UpcomingEventsCard";
import {ContentTitle, contentConfig, BORDER_COLOR, FONT_COLOR} from "./Dashboard/components/Extra";
import ThemeGrid from "../components/ThemeGrid";

const ApplicationsCard = ({categorizedApps})=>{
  return (
      <div className={contentConfig.className} style={{...contentConfig.style, maxWidth: 700}}>
          <Space direction={'vertical'} size={'large'} style={{width: '100%'}} >
            {categorizedApps.filter(x=>x.value.length>0).map((category, index) => (
                <div className={'round-2 p-2'}>
                  <Row className={'mb-3'} justify={'start'} style={{padding: '0 0 10px 0', borderRadius: '0'}}>
                    <Typography.Text className={'neumorphic-text'} style={{paddingLeft: '10px', fontSize: '1.2rem'}}>
                      {category.key}
                    </Typography.Text>
                  </Row>
                  <WidgetContainer widgets={category.value} center={false}  />
                </div>
            ))}
          </Space>
      </div>
  )
}


const Dashboard = ({ widgets }) => {
  const navigate = useNavigate();
  const portfolios = useSelector(selectPortfoliosWithSignals);
  const settings = useSelector((state) =>
    selectUserFields(state, "settings")
  );

  const starredPortfolios = useSelector(selectStarredPortfolios);
  const companyDetails = useSelector((state) =>
    selectUserFields(state, "company_details")
  );
  const categorizedApps = filterUserAppsIntoCategories(widgets.map(x=>x.key));
  const { events, uniqueSymbols } = useTickerCalendar();
  const sortedEvents = events && events.sort((a, b) => new Date(a.start) - new Date(b.start));

  const [selectedKey, setSelectedKey] = useState("1");

  const contentGridConfig = [
      {
          imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/dashboard-graphics/chessboard.jpeg',
          title: 'Portfolio Strategies',
          description: 'View and manage your portfolios',
            color: 'radial-gradient(#5C5B60, #2C2A29)'
      },
        {
            imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/dashboard-graphics/hard-hat.jpeg',
            title: 'Building Blocks',
            description: 'Stay up to date with upcoming events',
            color: 'linear-gradient(to bottom, #813617, #DD8D01)'
        },
      {
          imgUrl: 'https://storage.googleapis.com/finiat-web-static-resources/dashboard-graphics/laptop-half-closed.jpeg',
          title: 'Innovation Hub',
          description: 'View and manage your drafts',
          color: 'linear-gradient(#0000A4, #9A0081)'
      }
  ]

  return (
    <div className="app-home hide-scrollbar" style={{ height: "100%", overflowX: "hidden", overflowY: 'scroll'}}>
      <div>
          <Row
            justify="center"
            gutter={[4, 4]}
            align="top"
            wrap={true}
            style={{background: 'transparent'}}

          >
            <Col xs={22} xl={12} xxl={12} style={{padding: '0.5%', height: '90vh'}}>
              {portfolios.length > 0 && (
                <div style={{...contentConfig.style, maxWidth: 700, height: 120, paddingTop: 20}}>
                        <Alert variant={'outlined'} className={'cursor shadow-sm'} color={'info'} title={'Alert'} onClick={()=>navigate('/signals')} sx={{background: '#fff'}}
                           action={<StepForwardOutlined className={'mt-1'} onClick={()=>navigate('/signals')} style={{fontSize: '20px'}}/>}
                        >
                          <span style={{fontWeight: 500}} className={'px-1'}>{portfolios.length}</span>
                          Portfolios Have New Signals
                        </Alert>
              </div>
            )}
                <Tabs tabPosition={'left'}>
                    <Tabs.TabPane tab={'Apps'} key={'1'}>
                        <ApplicationsCard categorizedApps={categorizedApps} />
                    </Tabs.TabPane>
                    <Tabs.TabPane tab={'Ideas'}>
                        <div style={{maxWidth: 500, marginLeft: 20}}>
                            <ContentGrid items={contentGridConfig} />
                        </div>
                    </Tabs.TabPane>
                </Tabs>

                <Divider/>


            </Col>
            <Col xs={22} xl={12} xxl={12} style={{ height: '90vh'}} className={'pt-4'}>
              <UpcomingEventsCard events={sortedEvents} uniqueSymbols={uniqueSymbols} />
                <div style={{...contentConfig.style, padding: '1.25% 1.25% 1.25% 0'}} >
                    <ContentTitle title={'In Progress'}/>
                    <Space direction={'vertical'} style={{maxWidth: 550, margin: 'auto', width: '100%'}}>
                        <BuilderStatesManager />
                    </Space>
                </div>
            </Col>
          </Row>

      {selectedKey === "3" && (
        <Row justify="center">
          <Col className="p-6">
            <Divider />
            <PortfolioList
              peek={false}
              portfolios={starredPortfolios}
              backgroundImage={
                "https://storage.googleapis.com/finiat-web-static-resources/dramatic/black-podium.jpeg"
              }
            />
          </Col>
        </Row>
      )}
      </div>
    </div>
  );
};

export default Dashboard;
